import { useLocalStorage } from '../useStorage';

export const FILTER_SHORTCUT_HOTKEY = 'mod+f';

export const useFilterShortcut = () => {
  return useLocalStorage<boolean>('confidence-filter-shortcut-enabled', true);
};
